const ID = 'ID';
const ID_RECTO = 'ID_RECTO';
const ID_VERSO = 'ID_VERSO';
const PASSPORT = 'PASSPORT';
const RESIDENCY_PERMIT = 'RESIDENCY_PERMIT';
const ID_DOCUMENT_OTHER_SHOT = 'ID_DOCUMENT_OTHER_SHOT';
const DRIVER_LICENSE = 'DRIVER_LICENSE';
const PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS';
const PROOF_OF_ACCOMMODATION = 'PROOF_OF_ACCOMMODATION';
const ID_HOST = 'ID_HOST';
const ID_RECTO_HOST = 'ID_RECTO_HOST';
const ID_VERSO_HOST = 'ID_VERSO_HOST';
const PASSPORT_HOST = 'PASSPORT_HOST';
const DRIVER_LICENSE_HOST = 'DRIVER_LICENSE_HOST';
const PROOF_OF_ADDRESS_HOST = 'PROOF_OF_ADDRESS_HOST';
const RESIDENCE_PERMIT_RECTO = 'RESIDENCE_PERMIT_RECTO';
const RESIDENCE_PERMIT_VERSO = 'RESIDENCE_PERMIT_VERSO';
const RESIDENCE_PERMIT_ACKNOWLEDGEMENT = 'RESIDENCE_PERMIT_ACKNOWLEDGEMENT';
const RESIDENCE_PERMIT_RECTO_HOST = 'RESIDENCE_PERMIT_RECTO_HOST';
const RESIDENCE_PERMIT_VERSO_HOST = 'RESIDENCE_PERMIT_VERSO_HOST';
const VISA = 'VISA';

// Used to create a dummy ID document until we receive the real ID documents from Fourthline
const FOURTHLINE_GENERIC_ID_DOCUMENT = 'FOURTHLINE_GENERIC_ID_DOCUMENT';

const COMPANY_REGISTRATION = 'COMPANY_REGISTRATION';
const SWORN_STATEMENT = 'SWORN_STATEMENT';
const BANK_IDENTITY_STATEMENT = 'BANK_IDENTITY_STATEMENT';
const PROXY_GRANTING = 'PROXY_GRANTING';
const OFFICIAL_TAX_CERTIFICATE = 'OFFICIAL_TAX_CERTIFICATE';
const BUSINESS_LEGAL_STATUS = 'BUSINESS_LEGAL_STATUS';

// Used for manual verification through our customer support
const SELFIE_WITH_ID = 'SELFIE_WITH_ID';

const SELFIE = 'SELFIE';
const VIDEO = 'VIDEO';

const FOURTHLINE_REPORT = 'FOURTHLINE_REPORT';

const GENERIC = 'GENERIC';

const KYC_DOCUMENTS_TYPES = [
  ID,
  ID_RECTO,
  ID_VERSO,
  PASSPORT,
  RESIDENCY_PERMIT,
  ID_DOCUMENT_OTHER_SHOT,
  DRIVER_LICENSE,
  PROOF_OF_ADDRESS,
  PROOF_OF_ACCOMMODATION,
  ID_HOST,
  ID_RECTO_HOST,
  ID_VERSO_HOST,
  PASSPORT_HOST,
  DRIVER_LICENSE_HOST,
  PROOF_OF_ADDRESS_HOST,
  RESIDENCE_PERMIT_RECTO,
  RESIDENCE_PERMIT_VERSO,
  RESIDENCE_PERMIT_ACKNOWLEDGEMENT,
  RESIDENCE_PERMIT_RECTO_HOST,
  RESIDENCE_PERMIT_VERSO_HOST,
  VISA,
  GENERIC,
  FOURTHLINE_GENERIC_ID_DOCUMENT,
  FOURTHLINE_REPORT,
];

const KYB_DOCUMENTS_TYPES = [
  COMPANY_REGISTRATION,
  SWORN_STATEMENT,
  BANK_IDENTITY_STATEMENT,
  PROXY_GRANTING,
  OFFICIAL_TAX_CERTIFICATE,
  BUSINESS_LEGAL_STATUS,
];

const kycDocumentsTypesLocales = {
  en: {
    ADDRESS: 'JDD',
    BANK_IDENTITY_STATEMENT: 'RIB',
    BUSINESS_LEGAL_STATUS: 'Business legal statuses',
    COMPANY_REGISTRATION: 'Kbis',
    DRIVER_LICENSE: 'Driver License',
    DRIVER_LICENSE_HOST: 'Driver License host',
    FOURTHLINE_GENERIC_ID_DOCUMENT: 'ID document',
    FOURTHLINE_REPORT: 'Fourthline report',
    GENERIC: 'Other',
    ID: 'ID card',
    ID_DOCUMENT_OTHER_SHOT: 'ID document (other shot)',
    ID_HOST: 'ID card host',
    ID_RECTO: 'ID card (recto)',
    ID_RECTO_HOST: 'ID card host (recto)',
    ID_VERSO: 'ID card (verso)',
    ID_VERSO_HOST: 'ID card host (verso)',
    KBIS: 'Kbis',
    OFFICIAL_TAX_CERTIFICATE: 'Tax certificate',
    PASSPORT: 'Passport',
    PASSPORT_HOST: 'Passport host',
    PROOF_OF_ACCOMMODATION: 'Proof of Accommodation',
    PROOF_OF_ADDRESS: 'Proof of address',
    PROOF_OF_ADDRESS_HOST: 'Proof of address host',
    PROXY_GRANTING: 'Proxy granting',
    RESIDENCE_PERMIT_ACKNOWLEDGEMENT: 'Residence permit acknowledgement',
    RESIDENCE_PERMIT_RECTO: 'Residence permit (recto)',
    RESIDENCE_PERMIT_RECTO_HOST: 'Residence permit host (recto)',
    RESIDENCE_PERMIT_VERSO: 'Residence permit (verso)',
    RESIDENCE_PERMIT_VERSO_HOST: 'Residence permit host (verso)',
    RESIDENCY_PERMIT: 'Residence permit',
    SELFIE: 'Selfie',
    SELFIE_WITH_ID: 'Selfie with ID',
    STATUS: 'Status',
    SWORN_STATEMENT: 'Sworn statement',
    VIDEO: 'Video',
    VISA: 'Visa',
  },
  fr: {
    ADDRESS: 'Justificatif de domicile',
    BANK_IDENTITY_STATEMENT: 'RIB',
    BUSINESS_LEGAL_STATUS: 'Statuts de l’entreprise',
    COMPANY_REGISTRATION: 'Kbis',
    DRIVER_LICENSE: 'Permis de conduire',
    DRIVER_LICENSE_HOST: 'Permis de conduire hébergeur',
    FOURTHLINE_GENERIC_ID_DOCUMENT: "Pièce d'identité",
    FOURTHLINE_REPORT: 'Rapport Fourthline',
    GENERIC: 'Autre document',
    ID: 'Carte d’identité',
    ID_DOCUMENT_OTHER_SHOT: "Pièce d'identité (autre cliché)",
    ID_HOST: 'Carte d’identité hébergeur',
    ID_RECTO: 'Carte d’identité (recto)',
    ID_RECTO_HOST: 'Carte d’identité hébergeur (recto)',
    ID_VERSO: 'Carte d’identité (verso)',
    ID_VERSO_HOST: 'Carte d’identité hébergeur (verso)',
    KBIS: 'Kbis',
    OFFICIAL_TAX_CERTIFICATE: 'Certificat d’imposition',
    PASSPORT: 'Passeport',
    PASSPORT_HOST: 'Passeport hébergeur',
    PROOF_OF_ACCOMMODATION: 'Justificatif d’hébergement',
    PROOF_OF_ADDRESS: 'Justificatif de domicile',
    PROOF_OF_ADDRESS_HOST: 'Justificatif de domicile hébergeur',
    PROXY_GRANTING: 'Pouvoir (Proxy)',
    RESIDENCE_PERMIT_ACKNOWLEDGEMENT: 'Récépissé titre de séjour',
    RESIDENCE_PERMIT_RECTO: 'Titre de séjour (recto)',
    RESIDENCE_PERMIT_RECTO_HOST: 'Titre de séjour hébergeur (recto)',
    RESIDENCE_PERMIT_VERSO: 'Titre de séjour (verso)',
    RESIDENCE_PERMIT_VERSO_HOST: 'Titre de séjour hebergeur (verso)',
    RESIDENCY_PERMIT: 'Titre de séjour',
    SELFIE: 'Selfie',
    SELFIE_WITH_ID: 'Selfie avec pièce d’identité',
    STATUS: 'Statuts de l’entreprise',
    SWORN_STATEMENT: 'Déclaration sur l’honneur',
    VIDEO: 'Vidéo',
    VISA: 'Visa',
  },
};

module.exports = {
  BANK_IDENTITY_STATEMENT,
  BUSINESS_LEGAL_STATUS,
  COMPANY_REGISTRATION,
  DRIVER_LICENSE,
  DRIVER_LICENSE_HOST,
  FOURTHLINE_GENERIC_ID_DOCUMENT,
  FOURTHLINE_REPORT,
  GENERIC,
  ID,
  ID_DOCUMENT_OTHER_SHOT,
  ID_HOST,
  ID_RECTO,
  ID_RECTO_HOST,
  ID_VERSO,
  ID_VERSO_HOST,
  KYB_DOCUMENTS_TYPES,
  KYC_DOCUMENTS_TYPES,
  kycDocumentsTypesLocales,
  OFFICIAL_TAX_CERTIFICATE,
  PASSPORT,
  PASSPORT_HOST,
  PROOF_OF_ACCOMMODATION,
  PROOF_OF_ADDRESS,
  PROOF_OF_ADDRESS_HOST,
  PROXY_GRANTING,
  RESIDENCE_PERMIT_ACKNOWLEDGEMENT,
  RESIDENCE_PERMIT_RECTO,
  RESIDENCE_PERMIT_RECTO_HOST,
  RESIDENCE_PERMIT_VERSO,
  RESIDENCE_PERMIT_VERSO_HOST,
  RESIDENCY_PERMIT,
  SELFIE,
  SELFIE_WITH_ID,
  SWORN_STATEMENT,
  VIDEO,
  VISA,
};
